export const whyUsProofSummaries = [
  <>
    We have built and moderated active communities{" "}
    <span className="font-normal text-white/95">since 2016</span>—from earning{" "}
    <span className="font-normal text-white/95">Discord Partner</span> through
    genuine participation to helping{" "}
    <span className="font-normal text-white/95">FC Barcelona</span> and major
    gaming creators bring people together.
  </>,
  <>
    We create websites, bots, and AI-powered systems that remove friction from{" "}
    <span className="font-normal text-white/95">
      onboarding, moderation, analytics, and events
    </span>
    —tools that serve the community instead of distracting from it.
  </>,
  <>
    <span className="font-normal text-white/95">
      Strategy, execution, and technology
    </span>{" "}
    stay aligned from day one, giving you clear processes, measurable outcomes,
    and a team that understands sustainable{" "}
    <span className="font-normal text-white/95">community growth</span>.
  </>,
];
